import { Pipe, PipeTransform } from '@angular/core';
import { Stock } from '@stockcare-storage/stock/stock';

@Pipe({
  standalone: false,
  name: 'filterMaterial',
})
export class FilterMaterialPipe implements PipeTransform {
  transform(items: Stock[], filterBy: string): any {
    if (items === undefined) return;
    if (filterBy === '' || filterBy === undefined) return items;
    return items.filter(
      (item) => item.barcode.toLowerCase().includes(filterBy.toLowerCase()) || item.name.toLowerCase().includes(filterBy.toLowerCase())
    );
  }
}
